<script setup lang="ts">
import { ComboboxOption } from '@headlessui/vue'

const props = defineProps<{
  query: string
}>()
const store = useMainStore()
const id = computed(() => parseInt(props.query.trim()))
const possibleChannel = computed(() =>
  store.channels.find((c) => c.id === id.value),
)

const router = useRouter()
const shortcuts = computed(() => {
  return [
    possibleChannel.value
      ? {
          id: `shortcut-channel-${id.value}`,
          name: `Channel #${id.value}`,
          description: 'Navigate to channel by ID',
          icon: 'i-icon-park-outline:world',
          action: () => router.push(`/channels/${id.value}`),
        }
      : null,
    {
      id: `shortcut-p-${id.value}`,
      name: `Product #${id.value}`,
      description: 'Navigate to product by ID',
      icon: 'i-icon-park-outline:shopping-bag-one',
      action: () => router.push(`/products/${id.value}`),
    },
    {
      id: `shortcut-o-${id.value}`,
      name: `Order #${id.value}`,
      description: 'Navigate to order by ID',
      icon: 'i-icon-park-outline:shopping-cart-one',
      action: () => router.push(`/orders/${id.value}`),
    },
    {
      id: `shortcut-pm-${id.value}`,
      name: `Payment Method #${id.value}`,
      description: 'Navigate to payment method by ID',
      icon: 'i-icon-park-outline:wallet',
      action: () => router.push(`/payment-methods/${id.value}`),
    },
    {
      id: `shortcut-dm-${id.value}`,
      name: `Delivery Method #${id.value}`,
      description: 'Navigate to delivery method by ID',
      icon: 'i-icon-park-outline:truck',
      action: () => router.push(`/delivery-methods/${id.value}`),
    },
    {
      id: `shortcut-pf-${id.value}`,
      name: `Product Filter #${id.value}`,
      description: 'Navigate to product filter by ID',
      icon: 'i-icon-park-outline:filter',
      action: () => router.push(`/product-filters/${id.value}`),
    },
    {
      id: `shortcut-c-${id.value}`,
      name: `Category #${id.value}`,
      description: 'Navigate to category by ID',
      icon: 'i-icon-park-outline:folder-open',
      action: () => router.push(`/categories/${id.value}`),
    },
    {
      id: `shortcut-inspiration-${id.value}`,
      name: `Inspiration #${id.value}`,
      description: 'Navigate to inspiration by ID',
      icon: 'i-icon-park-outline:platte',
      action: () => router.push(`/inspirations/${id.value}`),
    },
    {
      id: `shortcut-promo-${id.value}`,
      name: `Promotion #${id.value}`,
      description: 'Navigate to promotion by ID',
      icon: 'i-icon-park-outline:percentage',
      action: () => router.push(`/products/promotions/${id.value}`),
    },
  ].filter(Boolean)
})
</script>
<template>
  <div
    class="px-4 py-4 bg-gray-50 text-xs font-medium text-gray-500 uppercase d"
  >
    ID Shortcuts
  </div>
  <ComboboxOption
    v-if="shortcuts.length"
    v-for="item in shortcuts"
    :key="item.id"
    :value="item"
    v-slot="{ active }"
    as="template"
  >
    <CommandPaletteItem :item="item" :active="active" />
  </ComboboxOption>
</template>
